import React , { useEffect, useState }from 'react'
import { Col, Container, Input, InputGroup, Row } from 'reactstrap'
import Home from "../Authentication/Home";
import Countdown from "react-countdown"
import { ToastContainer, toast } from 'react-toastify';

import { Link, useNavigate } from "react-router-dom";
//import images
import comingsoon from '../../assets/images/comingsoon.png';

const HomeIndex = (props) => {
    
    const [password, setPassword] = useState("");
    const history = useNavigate();
    const goLogin = () => { 
        if(password === "seednations2025") {
         history("/login");
        } else {
            errornotify("Invalid password");
        }
    };
    const errornotify = (error) => toast(error, { position: "top-center", hideProgressBar: true, closeOnClick: false, className: 'bg-danger text-white' });
 
    function handleInput(value) { 
        setPassword(value);
      }
       
    document.title="Seed Nations Coming Soon";
    return (
        <React.Fragment>
          <ToastContainer />
            <Home>
                <div className="auth-page-content">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <div className="text-center mt-sm-5 pt-4 mb-4">
                                    <div className="mb-5">
                                        <h1 className="display-2 home-text1">Coming Soon...</h1>
                                    </div>
                                    <div className="mb-5">
                                        <span className="home-text2">Seed Nationas will launch Q4 2025.</span>
                                    </div>
                                    <div>
                                        <InputGroup className="email-input-group mx-auto my-4 mt-5">
                                            <Input 
                                                value={password} 
                                                onChange={(e) => handleInput(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        goLogin();
                                                    }
                                                }}
                                                className="form-control border-light shadow home-input" 
                                                placeholder="Enter your password" 
                                            />
                                            <button 
                                                className="btn btn-dark" 
                                                type="button" 
                                                onClick={goLogin}
                                            >
                                                SUBMIT
                                                <i className="ri-send-plane-2-fill align-bottom ms-2"></i>
                                            </button>
                                        </InputGroup>
                                    </div>
                                    
                                    <div className="mt-5">
                                        <i className="ri-play-circle-fill align-bottom ms-2"></i>
                                        <span className="text-muted">prelaunch trailer coming soon</span>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                    </Container>

                </div>
            </Home>
        </React.Fragment>
    )
}

export default HomeIndex